import { render, staticRenderFns } from "./TeamsCallAmbulance.vue?vue&type=template&id=08725481&scoped=true&"
import script from "./TeamsCallAmbulance.vue?vue&type=script&lang=ts&"
export * from "./TeamsCallAmbulance.vue?vue&type=script&lang=ts&"
import style0 from "./TeamsCallAmbulance.vue?vue&type=style&index=0&id=08725481&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08725481",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!D:/a/1/s/frontend/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib'
import { VProgressCircular } from 'vuetify/lib'
installComponents(component, {VIcon,VProgressCircular})
